
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"21","viewBox":"0 0 28 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.412 1.539a.705.705 0 00-.735.06L7.2 5.615H1.768a.705.705 0 00-.705.705v9.06c0 .39.316.705.705.705H7.2l5.477 4.017a.704.704 0 001.122-.569V2.168a.705.705 0 00-.387-.629zM12.39 18.142l-4.541-3.33a.705.705 0 00-.417-.136H2.473v-7.65h4.958c.15 0 .296-.049.417-.137l4.54-3.33v14.583z","fill":"currentColor","stroke":"currentColor","stroke-width":"1.203"}}),_c('path',{attrs:{"d":"M18.296 6.429c.52-.52 1.36-.52 1.88 0l2.542 2.543 2.543-2.543a1.329 1.329 0 111.88 1.88l-2.543 2.543 2.543 2.544a1.329 1.329 0 11-1.88 1.88l-2.543-2.543-2.543 2.543a1.33 1.33 0 01-1.88 0c-.519-.52-.519-1.36 0-1.88l2.544-2.544-2.543-2.543c-.52-.52-.52-1.36 0-1.88z","fill":"currentColor"}})])
          )
        }
      }
    